import { IActionMap } from '@omaze/redux';

import { createModalActionType } from './Modal.factories';

export const MODAL_ACTION: IActionMap = {
    SHOW: createModalActionType('show'),
    HIDE: createModalActionType('hide'),
};
